var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentPayPalPayinthree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Paypal-Badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 40,
    viewBox: "0 0 85 55.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .pp-cls-1 {\n        fill: #f9f9f9;\n      }\n\n      .pp-cls-2 {\n        fill: #009cde;\n      }\n\n      .pp-cls-3 {\n        fill: #003087;\n      }\n\n      .pp-cls-4 {\n        fill: #012169;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paypal"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card",
    className: "pp-cls-1",
    width: 85,
    height: 55.857,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(19.702 7.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "pp-cls-2",
    d: "M16.384-1.8c-.194,1.28-1.164,1.28-2.1,1.28h-.534L14.122-2.9a.3.3,0,0,1,.291-.251h.245c.639,0,1.243,0,1.554.366a1.2,1.2,0,0,1,.172.994m-.409-3.339H12.434a.494.494,0,0,0-.487.418L10.517,4.425a.3.3,0,0,0,.067.239.3.3,0,0,0,.224.1h1.817a.345.345,0,0,0,.34-.292l.406-2.593a.493.493,0,0,1,.486-.418h1.12a3.644,3.644,0,0,0,4.031-3.389,2.76,2.76,0,0,0-.452-2.3,3.272,3.272,0,0,0-2.581-.911",
    transform: "translate(14.745 33.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "pp-cls-3",
    d: "M5.984-1.8C5.79-.515,4.82-.515,3.88-.515H3.346L3.721-2.9a.3.3,0,0,1,.291-.251h.245c.639,0,1.243,0,1.554.366a1.2,1.2,0,0,1,.172.994M5.575-5.134H2.034a.494.494,0,0,0-.486.418L.116,4.425a.3.3,0,0,0,.067.239.294.294,0,0,0,.224.1H2.1a.493.493,0,0,0,.486-.418l.387-2.466a.493.493,0,0,1,.486-.418h1.12A3.644,3.644,0,0,0,8.608-1.923a2.76,2.76,0,0,0-.452-2.3,3.272,3.272,0,0,0-2.581-.911M13.8,1.487a1.9,1.9,0,0,1-1.914,1.63,1.427,1.427,0,0,1-1.139-.461,1.457,1.457,0,0,1-.266-1.2,1.9,1.9,0,0,1,1.9-1.643,1.425,1.425,0,0,1,1.13.465A1.477,1.477,0,0,1,13.8,1.487M16.16-1.837h-1.7a.3.3,0,0,0-.292.251l-.074.477-.119-.173a2.4,2.4,0,0,0-2-.716A3.909,3.909,0,0,0,8.191,1.437,3.239,3.239,0,0,0,8.823,4.06a2.645,2.645,0,0,0,2.135.868,3.238,3.238,0,0,0,2.348-.976l-.076.474a.3.3,0,0,0,.067.239.294.294,0,0,0,.225.1h1.527a.493.493,0,0,0,.486-.418l.917-5.844a.3.3,0,0,0-.068-.239.3.3,0,0,0-.225-.1",
    transform: "translate(-0.113 33.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "pp-cls-2",
    d: "M19.475-.359a1.9,1.9,0,0,1-1.914,1.63A1.427,1.427,0,0,1,16.422.811a1.457,1.457,0,0,1-.266-1.2,1.9,1.9,0,0,1,1.9-1.643,1.425,1.425,0,0,1,1.13.465,1.477,1.477,0,0,1,.288,1.207m2.363-3.323h-1.7a.3.3,0,0,0-.292.251l-.074.477-.119-.173a2.4,2.4,0,0,0-2-.716A3.91,3.91,0,0,0,13.869-.409,3.239,3.239,0,0,0,14.5,2.214a2.645,2.645,0,0,0,2.135.868,3.239,3.239,0,0,0,2.348-.976l-.076.474a.3.3,0,0,0,.067.239.293.293,0,0,0,.224.1h1.526a.494.494,0,0,0,.487-.418l.917-5.844a.3.3,0,0,0-.068-.239.3.3,0,0,0-.225-.1",
    transform: "translate(19.467 35.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "pp-cls-3",
    d: "M15.087-3.776h-1.7a.489.489,0,0,0-.406.217L10.625-.073l-1-3.35a.494.494,0,0,0-.472-.354H7.481a.3.3,0,0,0-.24.124.3.3,0,0,0-.039.269L9.078,2.163,7.313,4.671a.3.3,0,0,0-.021.308.3.3,0,0,0,.262.161h1.7a.492.492,0,0,0,.4-.213L15.329-3.31a.3.3,0,0,0,.019-.307.3.3,0,0,0-.261-.159",
    transform: "translate(9.992 35.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "pp-cls-2",
    d: "M18.8-4.883,17.347,4.426a.3.3,0,0,0,.067.239.3.3,0,0,0,.224.1H19.1a.494.494,0,0,0,.486-.418L21.02-4.791a.3.3,0,0,0-.067-.239.294.294,0,0,0-.225-.1H19.093a.3.3,0,0,0-.292.251",
    transform: "translate(24.503 33.405)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(14.298 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    className: "pp-cls-3",
    d: "M7.511-3.719A.92.92,0,0,1,8.417-4.5h5.745a12,12,0,0,1,1.895.138A7.915,7.915,0,0,1,17-4.149a5.17,5.17,0,0,1,1.012.406,4.738,4.738,0,0,0-.993-4.242c-1.093-1.252-3.066-1.789-5.591-1.789H4.095a1.052,1.052,0,0,0-1.036.891L.008,10.6a.636.636,0,0,0,.143.51.627.627,0,0,0,.478.222H5.153L6.29,4.074,7.511-3.719Z",
    transform: "translate(0 9.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    className: "pp-cls-2",
    d: "M15.165-7.292q-.034.217-.075.432c-.966,5-4.273,6.723-8.5,6.723H4.443A1.047,1.047,0,0,0,3.411.754L2.31,7.782,2,9.776a.557.557,0,0,0,.125.447.549.549,0,0,0,.419.194H6.355a.92.92,0,0,0,.906-.779l.037-.2.719-4.586L8.062,4.6a.92.92,0,0,1,.907-.779H9.54c3.694,0,6.587-1.51,7.432-5.881.352-1.826.17-3.351-.763-4.422a3.645,3.645,0,0,0-1.044-.811",
    transform: "translate(2.843 13.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    className: "pp-cls-4",
    d: "M13.317-7.253q-.221-.066-.456-.118c-.157-.035-.318-.066-.484-.092a11.768,11.768,0,0,0-1.9-.14H4.738a.918.918,0,0,0-.906.78L2.611.972,2.575,1.2A1.047,1.047,0,0,1,3.607.308h2.15c4.223,0,7.53-1.727,8.5-6.723.029-.148.053-.291.075-.432a5.2,5.2,0,0,0-.794-.338c-.071-.024-.143-.046-.217-.068",
    transform: "translate(3.679 12.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    className: "pp-cls-3",
    d: "M17.014-7.985c-1.092-1.253-3.066-1.79-5.591-1.79H4.1a1.052,1.052,0,0,0-1.037.891L.008,10.6a.636.636,0,0,0,.143.51.628.628,0,0,0,.478.222H5.154L6.29,4.076,6.255,4.3a1.048,1.048,0,0,1,1.033-.891h2.15c4.223,0,7.53-1.727,8.5-6.723q.043-.222.075-.432a4.741,4.741,0,0,0-.994-4.241",
    transform: "translate(0 9.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    className: "pp-cls-3",
    d: "M17.014-7.985c-1.092-1.253-3.066-1.79-5.591-1.79H4.1a1.052,1.052,0,0,0-1.037.891L.008,10.6a.636.636,0,0,0,.143.51.628.628,0,0,0,.478.222H5.154L6.29,4.076,6.255,4.3a1.048,1.048,0,0,1,1.033-.891h2.15c4.223,0,7.53-1.727,8.5-6.723q.043-.222.075-.432a4.741,4.741,0,0,0-.994-4.241",
    transform: "translate(0 9.775)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentPayPalPayinthree);
export default __webpack_public_path__ + "static/media/logo-payment-pay-pal-payinthree.79a7b4ab.svg";
export { ForwardRef as ReactComponent };